import InviteFriend8kGrid from './InviteFriend8kGrid'

export default InviteFriend8kGrid
// eslint-disable-next-line import/export
export * from './InviteFriend8kGrid'
